import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from './environments/environment'
import { setUpBranding } from '../libs/drrweb-lib/src/lib/shared/utils/branding'
import { register as registerSwiper } from 'swiper/element/bundle'
import { storeAppId } from '@aaa-mobile/drrweb-lib'

setUpBranding()
const urlParams = new URLSearchParams(window.location.search)
const appId = urlParams.get('appId') || urlParams.get('appid')
if (appId) {
  storeAppId(appId)
}
registerSwiper()

if (environment.optimize) {
  enableProdMode()
}

document.addEventListener('DOMContentLoaded', () => {
  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...appConfig.providers],
  })
    .then(() => {
      try {
        loadHotjar()
      } catch (e) {
        console.error(e)
      }
    })
    .catch((err) => console.error(err))
})

const loadHotjar = () =>
  ((h, o, t, j, a, r) => {
    h.hj =
      h.hj ||
      function () {
        ;(h.hj.q = h.hj.q || []).push(arguments)
      }
    h._hjSettings = { hjid: environment.hotjar, hjsv: 6 }
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
    a.appendChild(r)

    const scripts = document.getElementsByTagName('script')
    const hotjarSourceUrl = 'https://static.hotjar.com/c/hotjar-2789441.js?sv=6'
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].src === hotjarSourceUrl && environment.configTools) {
        console.log('HotJar loaded.')
      }
    }
  })(window as any, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
